class UserInfo {
    userName;
    name;
    roles;
}

export default UserInfo;